import React, { useState } from 'react';

interface AvatarProps {
    src?: string;
    alt?: string;
    fallback?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
    src,
    alt = 'User',
    fallback,
    size = 'md',
    className = ''
}) => {
    const [imageError, setImageError] = useState(false);

    const sizeClasses = {
        sm: 'w-8 h-8 text-[10px]',
        md: 'w-10 h-10 text-xs',
        lg: 'w-14 h-14 text-sm',
        xl: 'w-24 h-24 text-lg'
    };
    const sizePixels = {
        sm: 32,
        md: 40,
        lg: 56,
        xl: 96
    };

    const getInitials = (name: string) => name
            .split(' ')
            .map(n => n[0])
            .slice(0, 2)
            .join('')
            .toUpperCase();

    return (
        <div 
            className={`relative inline-flex items-center justify-center overflow-hidden rounded-full border-2 border-white bg-gray-100 shadow-sm dark:border-gray-700 dark:bg-gray-800 ${sizeClasses[size]}
                ${className}
            `}
        >
            {src && !imageError ? (
                // biome-ignore lint/a11y/noNoninteractiveElementInteractions: image load failure is not user interaction; it swaps to the fallback avatar.
                <img
                    src={src}
                    alt={alt}
                    width={sizePixels[size]}
                    height={sizePixels[size]}
                    className="h-full w-full object-cover"
                    onError={() => setImageError(true)}
                />
            ) : (
                <span className="select-none font-bold text-gray-500 dark:text-gray-400">
                    {fallback ? getInitials(fallback) : getInitials(alt)}
                </span>
            )}
        </div>
    );
};














